import Client from "@/http/client";
import { FeatureAnalyticsEventDto } from "@/http/dto/featureAnalytics";

const SESSION_KEY = "shiftlog-feature-analytics-session";

function createSessionId() {
  return `${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 12)}`;
}

function getSessionId() {
  try {
    const saved = sessionStorage.getItem(SESSION_KEY);
    if (saved) return saved;

    const created = createSessionId();
    sessionStorage.setItem(SESSION_KEY, created);
    return created;
  } catch {
    return createSessionId();
  }
}

export class FeatureAnalytics {
  static trackIssueStatusDashboard(
    hotelObjectId: string,
    event: FeatureAnalyticsEventDto,
  ) {
    if (!hotelObjectId) return;

    Client.post(`/v2/${hotelObjectId}/feature-analytics/issue-status-dashboard`, {
      ...event,
      sessionId: getSessionId(),
    }).catch(() => undefined);
  }
}
